"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendableEthersLiquity = void 0;
const sendTransaction = (tx) => tx.send();
/**
 * Ethers-based implementation of {@link @yeti/lib-base#SendableLiquity}.
 *
 * @public
 */
class SendableEthersLiquity {
    constructor(populatable) {
        this._populate = populatable;
    }
    // async receiptPerUnderlying(overrides?: EthersTransactionOverrides): Pro
    async vaultDeposit(vaultToken, amount, overrides) {
        return this._populate.vaultDeposit(vaultToken, amount, overrides).then(sendTransaction);
    }
    async vaultWithdraw(vaultToken, amount, overrides) {
        return this._populate.vaultWithdraw(vaultToken, amount, overrides).then(sendTransaction);
    }
    async PSMMintYUSD(USDCAmount, overrides) {
        return this._populate.PSMMintYUSD(USDCAmount, overrides).then(sendTransaction);
    }
    async PSMRedeemYUSD(USDCAmount, overrides) {
        return this._populate.PSMRedeemYUSD(USDCAmount, overrides).then(sendTransaction);
    }
    async approveToken(tokenAddress, toAddress, amount, overrides) {
        return this._populate.approveERC20(tokenAddress, toAddress, amount, overrides).then(sendTransaction);
    }
    async multipleApproveERC20(tokenAddresses, toAddresses, amounts) {
        return this._populate.multipleApproveERC20(tokenAddresses, toAddresses, amounts);
    }
    async mintToken(tokenAddress, overrides) {
        return this._populate.mintERC20(tokenAddress, overrides).then(sendTransaction);
    }
    async mintTokenNoLimit(tokenAddress, amount, overrides) {
        return this._populate.mintERC20NoLimit(tokenAddress, amount, overrides).then(sendTransaction);
    }
    // async mintYUSD(
    //   overrides?: EthersTransactionOverrides
    // ): Promise<SentEthersLiquityTransaction<void>> {
    //   return this._populate.mintYUSD(overrides).then(sendTransaction);
    // }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.openTrove} */
    async openTrove(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .openTrove(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.openTroveLeverUp} */
    async openTroveLeverUp(params, ICRWithFees, troveOpen, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .openTroveLeverUp(params, ICRWithFees, troveOpen, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.closeTrove} */
    closeTrove(overrides) {
        return this._populate.closeTrove(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.closeTroveUnleverUp} */
    closeTroveUnleverUp(params, overrides) {
        return this._populate.closeTroveUnleverUp(params, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.adjustTrove} */
    adjustTrove(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .adjustTrove(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.addCollLeverUp} */
    addCollLeverUp(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .addCollLeverUp(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.addCollLeverUp} */
    withdrawCollUnleverUp(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .withdrawCollUnleverUp(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.depositCollateral} */
    depositCollateral(collaterals, ICRWithFees, overrides) {
        return this._populate.depositCollateral(collaterals, ICRWithFees, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.withdrawCollateral} */
    withdrawCollateral(collaterals, ICRWithFees, overrides) {
        return this._populate.withdrawCollateral(collaterals, ICRWithFees, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.borrowYUSD} */
    borrowYUSD(amount, ICRWithFees, maxBorrowingRate, overrides) {
        return this._populate.borrowYUSD(amount, ICRWithFees, maxBorrowingRate, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.repayYUSD} */
    repayYUSD(amount, ICRWithFees, overrides) {
        return this._populate.repayYUSD(amount, ICRWithFees, overrides).then(sendTransaction);
    }
    /** @internal */
    setPrice(price, overrides) {
        return this._populate.setPrice(price, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.liquidate} */
    liquidate(address, liquidator, overrides) {
        return this._populate.liquidate(address, liquidator, overrides).then(sendTransaction);
    }
    // /** {@inheritDoc @yeti/lib-base#SendableLiquity.liquidateUpTo} */
    // liquidateUpTo(
    //   maximumNumberOfTrovesToLiquidate: number,
    //   overrides?: EthersTransactionOverrides
    // ): Promise<SentEthersLiquityTransaction<LiquidationDetails>> {
    //   return this._populate
    //     .liquidateUpTo(maximumNumberOfTrovesToLiquidate, overrides)
    //     .then(sendTransaction);
    // }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.depositYUSDInStabilityPool} */
    depositYUSDInStabilityPool(amount, overrides) {
        return this._populate
            .depositYUSDInStabilityPool(amount, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.withdrawYUSDFromStabilityPool} */
    withdrawYUSDFromStabilityPool(amount, overrides) {
        return this._populate.withdrawYUSDFromStabilityPool(amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.withdrawGainsFromStabilityPool} */
    withdrawGainsFromStabilityPool(overrides) {
        return this._populate.withdrawGainsFromStabilityPool(overrides).then(sendTransaction);
    }
    claimRewardsSwap(amount, swapAssets, reinvest, overrides) {
        return this._populate.claimRewardsSwap(amount, swapAssets, reinvest, overrides).then(sendTransaction);
    }
    stakeLPTokens(amount, overrides) {
        return this._populate.stakeLPTokens(amount, overrides).then(sendTransaction);
    }
    withdrawLPTokens(amount, overrides) {
        return this._populate.withdrawLPTokens(amount, overrides).then(sendTransaction);
    }
    stakeLPTokensOldFarm(amount, overrides) {
        return this._populate.stakeLPTokensOldFarm(amount, overrides).then(sendTransaction);
    }
    withdrawLPTokensOldFarm(amount, overrides) {
        return this._populate.withdrawLPTokensOldFarm(amount, overrides).then(sendTransaction);
    }
    getVeYetiStakeReward(overrides) {
        return this._populate.getVeYetiStakeReward(overrides).then(sendTransaction);
    }
    getFarmRewards(overrides) {
        return this._populate.getFarmRewards(overrides).then(sendTransaction);
    }
    getOldFarmRewards(overrides) {
        return this._populate.getOldFarmRewards(overrides).then(sendTransaction);
    }
    updateVEYETI(params, overrides) {
        return this._populate.updateVEYETI(params, overrides).then(sendTransaction);
    }
    notifyAllRewarders(overrides) {
        return this._populate.notifyAllRewarders(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.transferCollateralGainToTrove} */
    transferCollateralGainToTrove(overrides) {
        return this._populate.transferCollateralGainToTrove(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.sendYUSD} */
    sendYUSD(toAddress, amount, overrides) {
        return this._populate.sendYUSD(toAddress, amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.sendYETI} */
    sendYETI(toAddress, amount, overrides) {
        return this._populate.sendYETI(toAddress, amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.redeemYUSD} */
    redeemYUSD(amount, maxRedemptionRate, overrides) {
        return this._populate.redeemYUSD(amount, maxRedemptionRate, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @yeti/lib-base#SendableLiquity.claimCollateralSurplus} */
    claimCollateralSurplus(overrides) {
        return this._populate.claimCollateralSurplus(overrides).then(sendTransaction);
    }
}
exports.SendableEthersLiquity = SendableEthersLiquity;
//# sourceMappingURL=SendableEthersLiquity.js.map